module.exports = __webpack_public_path__ + "static/wholesale-03af4d6dc7f9b0a2f3200e83eac44882.svg";